import React, { useRef, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import emailjs from '@emailjs/browser';
import { Link } from 'react-router-dom';

const API_BASE_URL = 'https://us-central1-mariokarts-fee04.cloudfunctions.net/api';

const Finan = () => {
  const form = useRef();
  const [showMessage, setShowMessage] = useState(false);
  const [availableCars, setAvailableCars] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/cars`)
      .then(response => response.json())
      .then(data => {
        const carsForDropdown = data
          .filter(car => !car.isSold) // Only show available cars
          .sort((a, b) => { // Sort alphabetically by brand and model
            const nameA = `${a.brand} ${a.model}`.toUpperCase();
            const nameB = `${b.brand} ${b.model}`.toUpperCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          });
        setAvailableCars(carsForDropdown);
      })
      .catch(error => console.error('Error fetching cars for financing form:', error));
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    const btn = document.getElementById("button");
    btn.value = "Enviando...";

    emailjs.sendForm(
        'service_l53vg4e',
        'template_w9fwe0c',
        form.current,
        '1UveAOVqla-C_PKT7'
    )
    .then(() => {
        const formData = new FormData(form.current);
        const submissionData = Object.fromEntries(formData.entries());
        submissionData.formType = 'Financiación';

        fetch('https://us-central1-mariokarts-fee04.cloudfunctions.net/api/submissions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(submissionData),
        }).catch(error => {
            console.error('Failed to save submission:', error);
        });

        btn.value = "Enviar";
        form.current.reset();
        setShowMessage(true);
        setTimeout(() => {
            setShowMessage(false);
        }, 3000);
    }, (err) => {
        btn.value = "Enviar";
        alert(JSON.stringify(err));
    });
  };

  return (
    <div>
      <Helmet>
        <title>Financiación de vehículos a medida | Manacars</title>
        <meta name="description" content="Financia tu próximo coche en Manacars con condiciones adaptadas a ti. Simulación sin compromiso." />
        <link rel="canonical" href="https://manacars.es/financiacion" />
      </Helmet>
      {showMessage && (
        <div className="success-message">
          ¡Mensaje enviado con éxito!
        </div>
      )}
      <div id="container1">
        <h1 className="form-title2">&bull; Financiación &bull;</h1>
        <div className="underline"></div>
        <p style={{textAlign: 'center', margin: '20px'}}>En Manacars te ayudamos a financiar tu próximo coche con condiciones adaptadas a tu situación. Trabajamos con entidades financieras colaboradoras para ofrecerte cuotas a medida, sea cual sea el vehículo que elijas de nuestro inventario. Cuéntanos qué coche te interesa y te preparamos una simulación sin compromiso.</p>
        
        <div className="calculadora-cta-container">
          <h2 className="calculadora-cta-title">¿No te decides? Estima tu cuota</h2>
          <p className="calculadora-cta-text">Usa nuestra calculadora de financiación para obtener una cuota mensual estimada al instante y sin compromiso.</p>
          <Link to="/calculadora-financiacion" className="calculadora-cta-button">
            Ir a la Calculadora
          </Link>
        </div>

        <form id="form" className='form23' ref={form} onSubmit={sendEmail}>
          <div className="field">
            <label htmlFor="to_name">Nombre</label>
            <input type="text" name="to_name" id="to_name" />
          </div>
          <div className="field">
            <label htmlFor="from_name">Email</label>
            <input type="email" name="email" id="from_name" />
          </div>
          <div className="telephone">
            <label htmlFor="name">Teléfono</label>
            <input type="text" name="telephone" id="telephone_input" required />
          </div>
          <div>
            <label htmlFor="coche-select">Coche</label>
            <select name="coche" id="coche-select" required>
                <option value="">--Seleccione una opción--</option>
                {availableCars.map((car) => (
                    <option key={car.id} value={`${car.brand} ${car.model} - ${car.price}€`}>
                        {car.brand} {car.model} - {car.price}€
                    </option>
                ))}
            </select>
          </div>
          <div className="entrada">
            <label htmlFor="entrada">Entrada</label>
            <input type="text" name="entrada" id="entrada" required />
          </div>
          <div className="plazos">
            <label htmlFor="plazos">Plazos</label>
            <input type="text" name="plazos" id="plazos" required />
          </div>
          <div>
            <input type="checkbox" id="cbox2" value="second_checkbox" required />
            <label htmlFor="cbox2">De acuerdo con la política de privacidad</label>
          </div>
          <input className="button" type="submit" id="button" value="Enviar" />
        </form>
      </div>
    </div>
  );
}

export default Finan;